import { render, staticRenderFns } from "./RetirarNegativacao.vue?vue&type=template&id=053b97dc"
import script from "./RetirarNegativacao.vue?vue&type=script&lang=js"
export * from "./RetirarNegativacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports